<template>
  <div>
    <div class="remove-page userpage-bg-fill userpage-bg-fill--vox bg-vox-populi bg-animation">
      <div class="d-flex min-vh-100 justify-content-center align-items-start py-3">
        <b-col md="20" class="mx-auto app-login-box">

          <div class="modal-dialog mx-auto remove-dialog">
            <VueElementLoading :active="showLoading" spinner="ring" color="var(--primary)" />
            <div class="modal-content">
              <div class="modal-body">
                <div class="h5 modal-title text-center">
                  <br>
                  <v-img src="/images/logo_login.png" width="100%" height="138" contain align="center"></v-img>
                  <br>
                  <h4>
                    <div>{{ strings.title }}</div>
                  </h4>

                  <template v-if="!success">
                    <h6 class="mb-3 ml-3 mr3 text-left remove-explanation">
                      <span>{{ strings.explanation }}</span>
                    </h6>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-text-field
                        v-model="email"
                        :rules="emailRules"
                        :label="strings.emailLabel"
                        :placeholder="strings.emailPlaceholder"
                        required
                      />
                      <v-checkbox
                        v-model="confirmed"
                        :rules="confirmRules"
                        color="primary"
                        class="mt-2 remove-checkbox"
                        :label="strings.checkboxLabel"
                      />
                    </v-form>
                  </template>

                  <div v-else class="alert alert-success mt-3 text-left" role="alert">
                    <strong>{{ strings.successLead }}</strong>
                    {{ strings.successRest }}
                  </div>
                </div>
              </div>
              <div v-if="!success" class="modal-footer clearfix">
                <div class="float-right">
                  <b-button
                    variant="primary"
                    size="lg"
                    :disabled="!canSubmit"
                    @click="submitRequest"
                  >
                    {{ strings.submit }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center text-white opacity-8 mt-3">Copyright &copy; Onikom Ltd</div>
        </b-col>
      </div>
    </div>
  </div>
</template>

<script>
import AppService from "../services/app.service";
import VueElementLoading from "vue-element-loading";

function detectBrowserLocale() {
  const raw = (
    typeof navigator !== "undefined" &&
    (navigator.language || navigator.userLanguage || "")
  )
    .toLowerCase()
    .trim();
  if (raw.startsWith("bg")) {
    return "bg";
  }
  return "en";
}

const UI = {
  bg: {
    title: "Заявка за изтриване на данни",
    explanation:
      "Тук можете да подадете заявка за изтриване на личните данни, свързани с вашия акаунт, " +
      "в съответствие с приложимото законодателство. " +
      "Въведете имейл адреса, с който сте се регистрирали. След обработка на заявката ще " +
      "получите потвърждение на посочения адрес.",
    emailLabel: "E-mail",
    emailPlaceholder: "Вашият e-mail...",
    checkboxLabel:
      "Потвърждавам, че желая изтриване на данните, свързани с този имейл адрес.",
    successLead: "Заявката е приета.",
    successRest:
      "Ако акаунт с този имейл адрес съществува в системата, ще получите съобщение с " +
      "следващите стъпки. Ако не получите имейл в рамките на няколко работни дни, " +
      "проверете папката „Нежелана поща“ или се свържете с поддръжката.",
    submit: "Изпрати заявката",
    emailRequired: "Полето е задължително",
    emailInvalid: "Невалиден e-mail",
    confirmRequired: "Моля потвърдете заявката за изтриване",
  },
  en: {
    title: "Data deletion request",
    explanation:
      "Use this form to request deletion of personal data associated with your account, " +
      "in line with applicable law requirements. Enter the email address " +
      "you used to register. After your request is processed, you will receive a confirmation " +
      "at that address.",
    emailLabel: "E-mail",
    emailPlaceholder: "Your email address...",
    checkboxLabel:
      "I confirm that I want data associated with this email address to be deleted.",
    successLead: "Your request has been received.",
    successRest:
      "If an account exists for this email address, you will receive a message with next steps. " +
      "If you do not receive an email within a few business days, check your spam folder " +
      "or contact support.",
    submit: "Submit request",
    emailRequired: "This field is required",
    emailInvalid: "Invalid email address",
    confirmRequired: "Please confirm your deletion request",
  },
};

export default {
  name: "RemoveData",
  components: {
    VueElementLoading,
  },
  data() {
    return {
      locale: detectBrowserLocale(),
      email: "",
      confirmed: false,
      valid: true,
      success: false,
      showLoading: false,
    };
  },
  computed: {
    strings() {
      return this.locale === "bg" ? UI.bg : UI.en;
    },
    emailRules() {
      const s = this.strings;
      return [
        (v) => !!v || s.emailRequired,
        (v) => /.+@.+/.test(v) || s.emailInvalid,
      ];
    },
    confirmRules() {
      const s = this.strings;
      return [(v) => !!v || s.confirmRequired];
    },
    canSubmit() {
      return this.valid && this.confirmed && !!this.email.trim();
    },
  },
  methods: {
    submitRequest() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (!this.confirmed) {
        return;
      }
      this.showLoading = true;
      this.submitToApi()
        .then(() => {
          this.success = true;
        })
        .catch(() => {
          // reserved for API errors
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    submitToApi() {
      return AppService.requestUserRemoval(this.email.trim());
    },
  },
};
</script>

<style scoped>
.remove-explanation span {
  font-weight: 400;
  line-height: 1.45;
}

.remove-checkbox ::v-deep .v-label {
  font-size: 0.9rem;
  line-height: 1.35;
  text-align: left;
}

.remove-dialog {
  max-width: 720px;
  margin-top: 0;
  margin-bottom: 0;
}

@media (max-width: 576px) {
  .remove-page .min-vh-100 {
    align-items: flex-start !important;
  }

  .remove-dialog {
    width: calc(100vw - 1rem);
    max-width: calc(100vw - 1rem);
    margin-left: auto;
    margin-right: auto;
  }

  .remove-dialog .modal-content {
    width: 100%;
    max-height: calc(100dvh - 1.5rem);
    display: flex;
    flex-direction: column;
  }

  .remove-dialog .modal-body {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .remove-dialog .modal-footer .float-right {
    float: none !important;
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
